/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect} from 'react';
import css from '../blogger/Blogger.module.scss';
import classNames from 'classnames';
import {copyText} from '../../../../../functions/copyText';
import {useFullWidth} from '../../../../../hooks/useFullWidth';
import {SelectorWithSearch} from '../../../../../shared/Selectors';
import {useResolvedThemeMode} from '../../../../../hooks/useResolvedThemeMode';
import {IMaskInput} from 'react-imask';

const validateUrl = (value) =>
  typeof value === 'string' &&
  /^(https?:\/\/)?([a-z\d-]+\.)+[a-z]{2,}(:\d+)?(\/\S*)?$/i.test(value.trim());

const Settings = ({
  id,
  data,
  setSettingData,
  settingData,
  settingValidation,
  setSettingValidation,
  setSaveButtonState,
  saveButtonState,
  statusList,
  typeAdvertisementList,
  bayerList,
  bot,
}) => {
  useFullWidth(true);
  const mode = useResolvedThemeMode();

  const handleChange = (key, value) => {
    setSaveButtonState(1);
    setSettingData((prev) => ({...prev, [key]: value}));
  };

  useEffect(() => {
    const isStatusRequiresLink = settingData?.status === 2;
    const sourceLink = settingData?.source_link || '';
    const trimmed = sourceLink.trim();

    const isEmptyWhenRequired = isStatusRequiresLink && trimmed === '';
    const isInvalidUrl = trimmed !== '' && !validateUrl(trimmed);

    const newValidation = {
      source_link: isEmptyWhenRequired || isInvalidUrl,
    };

    setSettingValidation(newValidation);
  }, [settingData.source_link, settingData.status]);

  return (
    <div className='card mb-8'>
      <div className='card-header border-0 p-8 pb-0'>
        <div
          className='card-title'
          style={{width: '100%', display: 'flex', justifyContent: 'space-between'}}
        >
          <span className='text-gray-900'>Настройки</span>
          <span className='badge badge-light-primary'>telegram</span>
        </div>
      </div>
      <div className='card-body p-8'>
        <div className={css.settings}>
          <div className={css.column}>
            {/* Название блогера */}
            <div className='fv-row fv-plugins-icon-container mb-6'>
              <label className='form-label'>Название</label>
              <input
                className='form-control form-control-lg form-control-solid'
                value={settingData.name || ''}
                onChange={(e) => handleChange('name', e.target.value)}
              />
            </div>

            <div className='fv-row fv-plugins-icon-container mb-6'>
              <label className='form-label'>
                {!data.traffic_category_id && (
                  <span className={css.label}>
                    <i className='bi bi-camera-video-fill fs-2 text-primary'></i>Источник рекламы
                  </span>
                )}
                {data.traffic_category_id === 1 && (
                  <span className={css.label}>
                    <span className={css.iconYoutube}></span>Youtube реклама
                  </span>
                )}
                {data.traffic_category_id === 2 && (
                  <span className={css.label}>
                    <i className='bi bi-instagram fs-2'></i>Instagram реклама
                  </span>
                )}
              </label>
              <div className={classNames(css.inputWrapper)}>
                <input
                  className='form-control form-control-lg form-control-solid'
                  value={settingData.source_link || ''}
                  onChange={(e) => handleChange('source_link', e.target.value)}
                />
                <button
                  className={classNames(css.copy)}
                  onClick={() => copyText(settingData.source_link || '')}
                >
                  <i className='ki-duotone ki-copy text-gray-500 p-0 fs-2'></i>
                </button>
              </div>
              {!!settingValidation?.source_link && (
                <div className='fs-6 fw-semibold form-label mb-2 text-danger'>
                  {settingData?.status === 2 && !settingData.source_link?.trim()
                    ? 'Ссылка на рекламу при статусе “Реклама вышла” не может быть пустая'
                    : 'Неправильная ссылка'}
                </div>
              )}
            </div>

            <div className='fv-row fv-plugins-icon-container mb-6'>
              <label className='form-label'>
                <span className={css.label}>Статус</span>
              </label>
              <div className={classNames(css.inputWrapper)}>
                <SelectorWithSearch
                  styles={{
                    control: (baseStyles) => ({
                      ...baseStyles,
                      minHeight: '45.5px',
                      borderRadius: '0.625rem',
                      boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.03)',
                      backgroundColor:
                        mode === 'dark'
                          ? 'var(--bs-gray-100) !important'
                          : 'var(--bs-gray-100) !important',
                    }),
                    indicatorSeparator: () => ({
                      display: 'none',
                    }),
                  }}
                  placeholder=''
                  options={statusList}
                  actions={(e) => {
                    setSettingData((prev) => ({...prev, status: e.value}));
                  }}
                  value={statusList.find((item) => item.value === settingData?.status)}
                  clearable={false}
                />
              </div>
            </div>

            <div className='fv-row fv-plugins-icon-container mb-6'>
              <label className='form-label'>
                <span className={css.label}>Сумма расходов</span>
              </label>
              <div className={classNames(css.inputWrapper)}>
                <IMaskInput
                  className='form-control form-control-lg form-control-solid'
                  // Маска з блоком для числа і фіксованим суфіксом
                  mask='num USD'
                  lazy={false} // показує суфікс одразу
                  unmask='typed' // повертає число в onAccept
                  inputMode='decimal' // мобільна клавіатура з крапкою
                  blocks={{
                    num: {
                      mask: Number,
                      scale: 2, // два знаки після крапки
                      radix: '.', // крапка як роздільник дробової частини
                      thousandsSeparator: ' ',
                      padFractionalZeros: true,
                      normalizeZeros: true,
                    },
                  }}
                  value={settingData?.cost}
                  onAccept={(val) => {
                    // val тут — це тип number (бо unmask="typed")
                    setSaveButtonState(1);
                    setSettingData((prev) => ({...prev, cost: val}));
                  }}
                />
              </div>
            </div>
          </div>

          <div className={css.column}>
            <div className='fv-row fv-plugins-icon-container mb-6'>
              <label className='form-label'>
                <span className={css.label}>Тип рекламы</span>
              </label>
              <div className={classNames(css.inputWrapper)}>
                <SelectorWithSearch
                  styles={{
                    control: (baseStyles) => ({
                      ...baseStyles,
                      minHeight: '45.5px',
                      borderRadius: '0.625rem',
                      boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.03)',
                      backgroundColor:
                        mode === 'dark'
                          ? 'var(--bs-gray-100) !important'
                          : 'var(--bs-gray-100) !important',
                    }),
                    indicatorSeparator: () => ({
                      display: 'none',
                    }),
                  }}
                  isDisabled={!typeAdvertisementList ? true : false}
                  placeholder=''
                  options={typeAdvertisementList}
                  actions={(e) => {
                    setSettingData((prev) => ({...prev, traffic_subcategory_id: e.value}));
                  }}
                  value={typeAdvertisementList?.find(
                    (item) => item.value === settingData?.traffic_subcategory_id
                  )}
                  clearable={false}
                />
              </div>
            </div>
            <div className='fv-row fv-plugins-icon-container mb-6'>
              <label className='form-label'>
                <span className={css.label}>Байер</span>
              </label>
              <div className={classNames(css.inputWrapper)}>
                <SelectorWithSearch
                  styles={{
                    control: (baseStyles) => ({
                      ...baseStyles,
                      minHeight: '45.5px',
                      borderRadius: '0.625rem',
                      boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.03)',
                      backgroundColor:
                        mode === 'dark'
                          ? 'var(--bs-gray-100) !important'
                          : 'var(--bs-gray-100) !important',
                    }),
                    indicatorSeparator: () => ({
                      display: 'none',
                    }),
                  }}
                  placeholder=''
                  options={bayerList}
                  actions={(e) => {
                    setSettingData((prev) => ({...prev, bayer_id: e.value}));
                  }}
                  value={bayerList?.find((item) => item.value === settingData?.bayer_id)}
                  clearable={false}
                />
              </div>
            </div>
            <div className='fv-row fv-plugins-icon-container mb-6'>
              <label className='form-label'>Домен</label>

              <div className={classNames(css.inputWrapper)}>
                <input
                  className='form-control form-control-lg form-control-solid'
                  value={`https://thl.ac` || ''}
                  disabled
                />
                <button
                  className={classNames(css.copy)}
                  onClick={() => copyText(`https://thl.ac/inf/${id}` || '')}
                >
                  <i className='ki-duotone ki-copy text-gray-500 p-0 fs-2'></i>
                </button>
              </div>
            </div>
            <div className='fv-row fv-plugins-icon-container mb-6'>
              <label className='form-label'>Бот</label>
              <input
                className='form-control form-control-lg form-control-solid'
                value={`#${bot?.id} ${bot?.name}` || ''}
                disabled
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
